import * as yup from 'yup';
import { stepComponentNames } from '../constants';

const getConditionalValidationString = (
    condition: boolean,
    message: string
) => {
    if (condition) {
        return yup.string().required(message);
    }

    return yup.string();
};

export const getValidationSchema = (
    stepComponentName: string,
    onlineOrder: boolean,
    isAvgSubject: boolean
) => {
    // 0-9, (), +, or -
    const phoneRegex = /[0-9+()-]*/;
    // 0000 followed by 6 numbers
    const orderNrRegexOnline = /^0000[0-9]{6}$/;
    // One or more digits, followed by a "/", followed by one or more digits
    const orderNrRegexStore = /^\s*[0-9]+\s*\/\s*[0-9]+\s*$/;

    if (stepComponentName === stepComponentNames.nameForm) {
        return {
            salutation: yup.string(),
            firstName: yup.string().required('Vul een voornaam in'),
            lastNamePrefix: yup.string(),
            lastName: yup.string().required('Vul een achternaam in'),
            customerEmail: yup
                .string()
                .email('Geen geldig e-mailadres')
                .required('Vul een e-mailadres in'),
            phoneNumber: yup
                .string()
                .matches(phoneRegex, 'Geen geldig telefoonnummer')
                .required('Vul een telefoonnummer in'),
        };
    }

    if (stepComponentName === stepComponentNames.addressForm) {
        return {
            street: yup.string().required('Vul de straatnaam in'),
            houseNumber: yup.string().required('Vul het huisnummer in'),
            houseNumberAddition: yup.string(),
            zipcode: yup.string().required('Vul de postcode in'),
            city: yup.string().required('Vul de plaatsnaam in'),
        };
    }

    if (stepComponentName === stepComponentNames.messageForm) {
        return {
            customerEmail: yup
                .string()
                .email('Geen geldig e-mailadres')
                .required('Vul een e-mailadres in'),
            message: getConditionalValidationString(
                !isAvgSubject,
                'Vul je bericht in'
            ),
        };
    }

    if (
        stepComponentName === stepComponentNames.storeSelect ||
        stepComponentName === stepComponentNames.storeSelectOptional
    ) {
        return {
            store: yup.string().required('Kies een winkel'),
        };
    }

    if (stepComponentName === stepComponentNames.orderNumberForm) {
        return {
            orderNumber: yup
                .string()
                .matches(
                    onlineOrder ? orderNrRegexOnline : orderNrRegexStore,
                    onlineOrder
                        ? 'Vul de 6 cijfers na 0000 in'
                        : 'Vul de cijfers in'
                )
                .required('Vul de cijfers in'),
        };
    }
};
